import React, { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [hovered, setHovered] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/projects`)
      .then(r => r.json())
      .then(data => setProjects(data))
      .catch(() => {});
  }, []);

  return (
    <div>
      <section data-testid="portfolio-header" className="portfolio-header-flex" style={{ borderBottom: "1px solid var(--border)", padding: "64px 24px 48px", maxWidth: 1140, margin: "0 auto", display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 24 }}>
        <div>
          <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 20, height: 1, background: "var(--gold)", display: "inline-block" }} />
            Portfólio
          </p>
          <h1 data-testid="portfolio-title" style={{ fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)", color: "var(--text)", letterSpacing: "-0.01em", maxWidth: 520 }}>
            Projetos e aplicações BIM
          </h1>
        </div>
        <p style={{ fontSize: "0.875rem", color: "var(--muted)", maxWidth: 340, lineHeight: 1.65 }}>
          Amostra dos tipos de empreendimentos em que a BIMtec atua — coordenação, modelagem disciplinar e implantação de processos.
        </p>
      </section>

      <section data-testid="portfolio-grid" className="grid-portfolio" style={{ maxWidth: 1140, margin: "0 auto", padding: "64px 24px", display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 1, background: "var(--border)" }}>
        {projects.map((project, i) => (
          <div key={project.id}
            data-testid={`portfolio-card-${project.id}`}
            onMouseEnter={() => setHovered(project.id)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => setSelectedProject(selectedProject === project.id ? null : project.id)}
            style={{ background: hovered === project.id ? "var(--surface2)" : "var(--bg)", padding: "36px 32px", cursor: "pointer", transition: "background 0.2s", display: "flex", flexDirection: "column" }}
          >
            <div style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.18em", color: hovered === project.id ? "var(--gold)" : "var(--muted2)", marginBottom: 20, transition: "color 0.2s", display: "flex", alignItems: "center", gap: 10 }}>
              {String(i + 1).padStart(2, "0")}
              <span style={{ flex: 1, height: 1, background: "var(--border)" }} />
              <span style={{ textTransform: "uppercase", fontSize: "0.58rem" }}>{project.segment}</span>
            </div>
            <div style={{ height: 4, background: hovered === project.id ? "linear-gradient(to right, var(--gold), var(--gold-dim))" : "var(--surface2)", borderRadius: 2, marginBottom: 24, transition: "background 0.3s" }} />
            <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: "1.05rem", color: "var(--text)", lineHeight: 1.3, marginBottom: 8 }}>{project.name}</h2>
            <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.1em", color: "var(--muted2)", marginBottom: 16, textTransform: "uppercase" }}>{project.location}</p>
            <p style={{ fontSize: "0.875rem", color: "var(--muted)", lineHeight: 1.65, flex: 1, marginBottom: 24 }}>{project.summary}</p>

            {/* Images gallery */}
            {selectedProject === project.id && project.images && project.images.length > 0 && (
              <div style={{ display: "grid", gridTemplateColumns: project.images.length === 1 ? "1fr" : "repeat(2, 1fr)", gap: 8, marginBottom: 20 }}>
                {project.images.map((img, idx) => (
                  <div key={idx} style={{ position: "relative", overflow: "hidden", borderRadius: 4, aspectRatio: "16/10", background: "var(--surface)" }}>
                    <img src={img} alt={`${project.name} - ${idx + 1}`}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
            )}
            {project.images && project.images.length > 0 && (
              <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.58rem", color: "var(--gold)", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 16 }}>
                {selectedProject === project.id ? "Clique para fechar" : `${project.images.length} imagem(ns) · Clique para ver`}
              </p>
            )}

            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {project.tags.map((tag) => (<span key={tag} className="tag">{tag}</span>))}
            </div>
          </div>
        ))}
      </section>

      {projects.length === 0 && (
        <div style={{ textAlign: "center", padding: 60, color: "var(--muted2)" }}>Carregando projetos...</div>
      )}
    </div>
  );
};

export default Portfolio;
